import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RamoAtividadeModel } from 'app/model/cliente/ramoatividade.model';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';

@Injectable()
export class RamoatividadeService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  getPageRamoAtividade(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-ramo?page=${page}&size=${size}`, this.httpOptions);
  }

  getRamo(): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-ramo', this.httpOptions)
  }

  postRamo(ramoAtividade: RamoAtividadeModel): Observable<RamoAtividadeModel>{
    return this.httpClient.post<RamoAtividadeModel>(this.apiURL + '/new/adicionar-ramo', ramoAtividade, this.httpOptions);
  }

  deleteRamo(id: any) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + '/delete/delete-ramo/' + id, { headers, responseType: 'text' })
  }

  putIndiceReajuste(ramoAtividade: RamoAtividadeModel): Observable<RamoAtividadeModel>{
    return this.httpClient.put<RamoAtividadeModel>(this.apiURL + '/edit/editar-ramo', ramoAtividade, this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/cliente/ramoatividade.service.ts